import { UserPreferenceFields } from "@sp-crm/core";
import { Toggle } from "components/ui/toggle";
import React from "react";
import { useCurrentUser } from "store/selectors/hooks";
import { useCommitUserPreference } from "./account-settings-hooks";

interface UserTogglePrefProps {
    description: string;
    field: UserPreferenceFields;
    label: string;
}

export const UserTogglePref: React.FC<UserTogglePrefProps> = props => {
    const { description, field, label } = props;
    const user = useCurrentUser();
    const commit = useCommitUserPreference(field);
    const onCommitCallback = React.useCallback(
        (isChecked: boolean) => {
            commit(isChecked);
        },
        [commit],
    );
    return (
        <div className="group">
            <Toggle
                checked={user.preferences[props.field] as boolean}
                onChange={onCommitCallback}
                label={
                    <div>
                        <span className="text-md">{label}</span>
                        {description ? (
                            <div className="text-gray-500 group-hover:text-gray-900 text-sm">
                                {description}
                            </div>
                        ) : null}
                    </div>
                }
            />
        </div>
    );
};
